// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VJsX","col":"styles_col__3eTND"};